import { render } from "./doors.vue?vue&type=template&id=5a7f48cc"
import script from "./doors.vue?vue&type=script&lang=js"
export * from "./doors.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__